export default __webpack_public_path__ + "static/carolina-5c6287b664d87e96418baf0cae4f24f0.jpg";